import React, { useContext, useState } from 'react'
import { Card, Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import moment from 'moment';
import './style-card.css'
import { IconButton, ScrollablePane, ScrollbarVisibility, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import CLabel from '../../../../../../Common/CLabel';
import { useGetBoardComponentInfoValuesDynamicList } from '../../../../../../../hooks/services/sKPI/useOfBoard';
import MainAppContext from '../../../../../../../MainAppContext';
import BoardAppContext from '../../../../../../../BoardAppContext';

function DynamicList(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);

    const {
        inputParam_BoardId = null,
        inputParam_ComponentInfo = null,
    } = props;
    const [oldType, setOldType] = useState(inputParam_ComponentInfo.componentTypeId)
    const [itemDataList, setitemDataList] = useState({data: null, showDocumentId: false, columns: [], headers: []})
    useGetBoardComponentInfoValuesDynamicList(
        inputParam_BoardId, 
        contextBoard.selectedElement.value.elementType.elementId, 
        inputParam_ComponentInfo.componentTypeId, 
        oldType,
        contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId,
        contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate,
        contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate,
        itemDataList, 
        setitemDataList,
        setOldType)

    const onItemClick = (itemId, redirectTo) => {
        window.open(redirectTo + '/' + itemId, "_blank");
    }

    const onRenderAditionalInformationElement = (itemId, documentId, redirectTo) => {
        return  <div className='d-flex'>
                    <div>
                        <IconButton onClick={ () => onItemClick(itemId, redirectTo) } iconProps={{ iconName: 'View' }} allowDisabledFocus>
                        </IconButton>
                    </div>
                    {
                        documentId !== null && documentId !== undefined &&
                        <div>
                            <IconButton onClick={ null } iconProps={{ iconName: 'Document' }} allowDisabledFocus>
                            </IconButton>
                        </div>
                    }
                </div>
    }

    return (
            <>
                <Row className='pb-2 d-none d-sm-flex border-bottom'>
                    {
                        itemDataList.headers !== null && itemDataList.headers.map((header, index) => (
                            index === 0 ?
                            <Col key={index}>
                                <b>{t(header.name)}</b>
                            </Col> :
                            <Col key={index} className='col-auto' style={{minWidth: "100px"}}>
                                <b>{t(header.name)}</b>
                            </Col>
                        ))
                    }
                </Row>
                <Row className='py-2'>
                    <Col>
                        <ScrollablePane
                            style={{ minHeight: "150px", maxHeight: "100%", height: "100%"}}
                            styles={{
                                root: { position: "relative" },
                                contentContainer:{overflowX: "hidden"}
                            }}
                            scrollbarVisibility={ScrollbarVisibility.auto}
                            scrollContainerFocus={true}
                        >
                            {
                                itemDataList.data !== null && itemDataList.data.map((item, indexItem) => (
                                    <div key={indexItem} className="pb-1">
                                        <Row>
                                            <Col>
                                                <Row>
                                                    {
                                                        itemDataList.columns !== null && itemDataList.columns.filter(x => x.colAuto === false).map((column, indexColumn) => (
                                                                <Col key={indexColumn} className='d-flex' style={{overflow: "hidden"}}>
                                                                    <CLabel labelText={t(column.fieldLangKeyword)}/>
                                                                    <TooltipHost
                                                                        content={column.isLangKeyword ? t(item[column.fieldName]) : column.isDate ? moment(item[column.fieldName]).format('DD/MM/YYYY') : item[column.fieldName] }
                                                                        overflowMode={TooltipOverflowMode.Parent}
                                                                    >
                                                                        <CLabel className="text-nowrap" labelValue={column.isLangKeyword ? t(item[column.fieldName]) : column.isDate ? moment(item[column.fieldName]).format('DD/MM/YYYY') : item[column.fieldName] } />
                                                                    </TooltipHost>
                                                                </Col>
                                                        ))
                                                    }
                                                </Row>
                                            </Col>
                                            {
                                                itemDataList.columns !== null && itemDataList.columns.filter(x => x.colAuto === true).map((column, indexColumn) => (
                                                    <Col key={indexColumn} className={column.colAuto ? 'col-auto d-flex' : 'd-flex'} style={{overflow: "hidden"}}>
                                                        <CLabel labelText={t(column.fieldLangKeyword)}/>
                                                        <TooltipHost
                                                            content={column.isLangKeyword ? t(item[column.fieldName]) : column.isDate ? moment(item[column.fieldName]).format('DD/MM/YYYY') : item[column.fieldName] }
                                                            overflowMode={TooltipOverflowMode.Parent}
                                                        >
                                                            <CLabel className="text-nowrap" labelValue={column.isLangKeyword ? t(item[column.fieldName]) : column.isDate ? moment(item[column.fieldName]).format('DD/MM/YYYY') : item[column.fieldName] } />
                                                        </TooltipHost>
                                                    </Col>
                                                ))
                                            }
                                            <Col className='col-auto' style={{minWidth: "100px"}}>
                                                {
                                                    onRenderAditionalInformationElement(item.id, item.itemUrl, itemDataList.showDocumentId ? item.documentId : null)
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                ))
                            }
                        </ScrollablePane>
                    </Col>
                </Row>
            </>
    );
}

DynamicList.propTypes = {
    inputParam_BoardId: PropTypes.number.isRequired,
    inputParam_ComponentInfo: PropTypes.object.isRequired,
};

export default DynamicList;

